var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Header'),_c('Navigation'),(_vm.ready)?_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }